module.exports = __webpack_public_path__ + "static/fonts/Fact-Thin.3a87838.woff";